export default __webpack_public_path__ + "static/withFam-15b5e5f72d06e1985515f787b41f0529.jpeg";